/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CurrentUserService } from '@rma/accounts/user';
import { DynamicAssetLoaderService, DynamicLoaderAssets } from '@rma/generic/util/dynamic-asset-loader';
import { FeatureFlags, FeatureFlagService } from '@rma/generic/util/feature-flags';
import { filter, switchMap, take } from 'rxjs/operators';
import { ChatApiService } from '../data-access/chat-api.service';

declare global {
  interface Window {
    intercomSettings?: any;
  }
  function Intercom(value: string, params?: any): void;
}

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  public isLoaded$ = new EventEmitter<boolean>();

  constructor(
    private readonly chatApiService: ChatApiService,
    private readonly userService: CurrentUserService,
    private readonly dynamicAssetLoader: DynamicAssetLoaderService,
    private readonly featureProvider: FeatureFlagService,
    @Inject(WA_WINDOW) private readonly window: Window,
  ) {}

  public initialise(): void {
    this.featureProvider
      .getFeature$(FeatureFlags.EnableIntercom, false)
      .pipe(
        filter((x) => x),
        switchMap(() => this.userService.currentUser$),
        filter((x) => x !== null && !x.isImpersonating),
        switchMap(() => this.chatApiService.userChatData$.pipe(take(1))),
        filter((x) => !!x.app_id),
        take(1),
        untilDestroyed(this),
      )
      .subscribe((x) => {
        this.window.intercomSettings = x;
        this.dynamicAssetLoader.load(DynamicLoaderAssets.Intercom).subscribe((y) => this.isLoaded$.emit(y));
      });
  }

  public showMessenger(): void {
    Intercom('show');
  }
}
